import "@/App.css";
import { PowerCalculator } from "@/components/PowerCalculator";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <PowerCalculator />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
